module.exports = __webpack_public_path__ + "static/media/landingService3.c2f1eac6.png";